import styled from 'styled-components';
import { Typography } from '@interstate/components/Typography';

export const StyledCard = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 16px;
    justify-content: space-between;
    align-self: stretch;
    border-radius: 4px;
    border: 1px solid var(--color-border-muted, #b2b2b2);
    background: var(--color-surface-app, #fafafa);
    margin-bottom: 20px;
`;

export const StyledCardHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
`;

export const StyledCreditSourceLabel = styled.div`
    display: flex;
    align-items: center;
    gap: 4px;
    margin-bottom: 4px;
`;

export const StyledLeftContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
`;

export const StyledCreditSourceText = styled(Typography)`
    && {
        color: var(--color-on-surface-muted, #6d6d6d);
        font-size: 12px;
        font-weight: 600;
        line-height: 7.5px;
        letter-spacing: 0.309px;
        text-transform: uppercase;
    }
`;

export const StyledSelfReportedText = styled(Typography)`
    && {
        color: #0f172a;
        font-size: var(--type-font-size-size-md, 16px);
        font-weight: var(--type-font-weight-weight-semibold, 600);
        line-height: 120%;
    }
`;

export const StyledBodyText = styled(Typography)`
    && {
        color: var(--color-on-surface-default, #000);
        font-size: var(--type-font-size-size-sm, 14px);
        font-weight: var(--type-font-weight-weight-regular, 400);
        line-height: 130%;
    }
`;
